var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.1519 2.29616L10.3251 4.66196C10.4851 4.99129 10.9117 5.30717 11.2717 5.36766L13.3981 5.72387C14.758 5.95239 15.078 6.94711 14.098 7.92837L12.4449 9.59517C12.1649 9.87744 12.0116 10.4218 12.0982 10.8117L12.5716 12.875C12.9448 14.5082 12.0849 15.14 10.6518 14.2864L8.65863 13.0968C8.2987 12.8818 7.70543 12.8818 7.33876 13.0968L5.34568 14.2864C3.91916 15.14 3.0526 14.5015 3.42589 12.875L3.89917 10.8117C3.98582 10.4218 3.83251 9.87744 3.55254 9.59517L1.89939 7.92837C0.926162 6.94711 1.23946 5.95239 2.59931 5.72387L4.72574 5.36766C5.07904 5.30717 5.50566 4.99129 5.66564 4.66196L6.83883 2.29616C7.47876 1.01245 8.51863 1.01245 9.1519 2.29616Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarAction);
export default __webpack_public_path__ + "static/media/star-action.796e31f30f8856d7dd883990f3b2ff51.svg";
export { ForwardRef as ReactComponent };